module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDAiIGhlaWdodD0iNDAwIiB2aWV3Qm94PSIwIDAgMjcgMTgiPjx0aXRsZT5GbGFnIG9mIFRoZSBHYW1iaWE8L3RpdGxlPjxwYXRoIGQ9Ik0wIDBoMjd2MThIMCIgZmlsbD0iIzNBNzcyOCIvPjxwYXRoIGQ9Ik0wIDBoMjd2MTFIMCIgZmlsbD0iIzBDMUM4QyIvPjxwYXRoIGQ9Ik0wIDBoMjd2NkgwIiBmaWxsPSIjQ0UxMTI2Ii8+PHBhdGggZD0iTTAgNi41aDI3bTAgNUgwIiBzdHJva2U9IiNGRkYiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/gmb.svg
// module id = snZc
// module chunks = 0